import React from 'react';
import { Typography, Box, Button, Paper, Container, styled } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { ROUTES } from '../../config/constants';

// Custom styled components
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: 16,
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  width: '100%',
  maxWidth: 500,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

/**
 * ExpiredLinkView Component
 *
 * Displays a friendly error message when an activation link has expired or is invalid
 * Provides options for the user to return home or contact support
 */
const ExpiredLinkView = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          gap: 3,
        }}
      >
        <ErrorOutlineIcon color="error" sx={{ fontSize: 80 }} />

        <Typography variant="h4" fontWeight="bold">
          Activation Link Expired
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          The organization activation link you used is either invalid or has expired.
        </Typography>

        <StyledPaper elevation={3} sx={{ p: 3, width: '100%' }}>
          <Typography variant="body1" gutterBottom>
            Please contact our support team to request a new activation link.
          </Typography>

          <Box sx={{ mt: 3, display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="outlined"
              onClick={() => window.close()}
              sx={{
                borderRadius: '8px',
                py: 1.5,
                px: 3,
                textTransform: 'none',
                fontWeight: 600,
              }}
            >
              Close
            </Button>

            <Button
              variant="contained"
              href="mailto:contact@cacxi.com?subject=Expired%20Activation%20Link&body=My%20organization%20activation%20link%20has%20expired.%20Please%20assist."
              sx={{
                borderRadius: '8px',
                py: 1.5,
                px: 3,
                textTransform: 'none',
                fontWeight: 600,
              }}
            >
              Email Support
            </Button>
          </Box>
        </StyledPaper>
      </Box>
    </Container>
  );
};

export default ExpiredLinkView;
